module.exports = __webpack_public_path__ + "static/media/arrow_down.b52c67cc.svg";